import { axios } from '@/config/plugins/axios';
import { Pagination, Rule } from '@/types';
import { ChipItem } from '@cnamts/vue-dot/src/elements/ChipList/types';

export interface projectListAdvanceSearch {
	'project-name': number[];
}
export interface projectListAdvanceSearchDOMFilter {
	choices?: [];
	formatChip?: (value: any) => ChipItem[];
	multiple?: boolean;
	searchAlias: string;
	fastAccess?: boolean;
	title: string;
	type: string;
	name: 'project-name';
	rules?: Rule[];
	tooltip?: string;
	value: number[];
}

const projectListService = {

	getProjectsList(
		projectUrl: string,
		pagination: Pagination,
		advancedSearch?: projectListAdvanceSearch
	) {
		const params = {
			itemsPerPage: pagination.itemsPerPage,
			sortDesc: pagination.sortDesc,
			page: pagination.page,
			sortBy: pagination.sortBy,
			advancedSearch
		};

		if (0 === pagination.sortBy?.length) {
			params.sortBy = null;
			params.sortDesc = null;
		}

		return axios.get(projectUrl, { params });
	},
	getProjectsListAdvancedSearch(projectURL: string) {
		return axios.get(`${projectURL}/advanced-search`);
	},
	isNumberArray(array: any) {
		return Array.isArray(array) && array.every(element => 'number' === typeof element);
	}
};

export default projectListService;
